import { render, staticRenderFns } from "./CoursePage.vue?vue&type=template&id=2b26b448&scoped=true&"
import script from "./CoursePage.vue?vue&type=script&lang=ts&"
export * from "./CoursePage.vue?vue&type=script&lang=ts&"
import style0 from "./CoursePage.vue?vue&type=style&index=0&id=2b26b448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b26b448",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2b26b448', component.options)
    } else {
      api.reload('2b26b448', component.options)
    }
    module.hot.accept("./CoursePage.vue?vue&type=template&id=2b26b448&scoped=true&", function () {
      api.rerender('2b26b448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/CoursePage.vue"
export default component.exports